import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-organization/$slug/pages")({
  staticData: { title: "Our pages" },
  component: () => <Outlet />,
});
